module.exports = __webpack_public_path__ + "img/1530441782.9dafc53a.jpg";